<div class="flex h-full min-h-0 w-full flex-col overflow-hidden gap-4">

  <!-- header -->
  <div
    class="flex w-full shrink-0 flex-col gap-2 border-b border-zinc-200 pb-2 dark:border-zinc-800 lg:items-center lg:justify-between">

    <!-- Top Tab Row -->
    <div class="w-full flex flex-row items-center justify-between">
      <div class="flex min-w-0 flex-1 gap-2 overflow-x-auto scrollbar-transparent" role="tablist"
        aria-label="Brief status">
        @for (tab of tabs; track tab) {
        <button type="button" role="tab" [class]="tabClass(tab)" [attr.aria-selected]="query().tab === tab"
          (click)="setTab(tab)">
          {{ tabLabel(tab) }}
          @if (loading() !== 'initial' && response(); as data) {
          <span [class]="countClass(tab)">{{ data.tabCounts[tab] }}</span>
          }
        </button>
        }
      </div>

      <div class="shrink-0 flex min-w-0 w-full flex-row flex-wrap items-center gap-2 lg:w-auto lg:justify-end">

        <atom-new-brief-type-select></atom-new-brief-type-select>

        <button *appHasRole="[77]" [routerLink]="['/create-brief-select-smart']" type="button"
          class="btn-fab-flashy-go">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-6">
            <path
              d="M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z" />
          </svg>
        </button>

      </div>
    </div>
    <!-- Top Tab Row - END -->

    <!-- Search & Filter Row -->
    <div class="flex flex-wrap items-center gap-2 w-full">
      <label class="relative min-w-0 flex-1 basis-72">
        <span class="sr-only">Search briefs</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          class="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-zinc-400" aria-hidden="true">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.3-4.3" />
        </svg>
        <input #searchInput id="brief-search" type="search" autocomplete="off"
          class="w-full rounded-lg border border-zinc-300 bg-white py-2 pl-9 pr-10 text-sm text-zinc-900 outline-none focus:border-primary dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100"
          placeholder="Search briefs, products or people" [value]="searchText()"
          (input)="onSearch($any($event.target).value)" />
        @if (searchText()) {
        <button type="button"
          class="absolute right-2 top-1/2 grid size-6 -translate-y-1/2 place-items-center rounded-md text-zinc-500 hover:bg-zinc-100 dark:hover:bg-zinc-800"
          aria-label="Clear search" (click)="clearSearch($event)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            class="size-3.5" aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
        } @else {
        <kbd
          class="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 rounded border border-zinc-200 px-1.5 text-xs font-bold text-zinc-400 dark:border-zinc-700"
          aria-hidden="true">/</kbd>
        }
      </label>

      @if (campaigns(); as campaignList) {
      <div class="flex shrink-0 items-center gap-2">
        <el-select class="block w-48" name="campaign">
          <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
            <span class="col-start-1 row-start-1 flex min-w-0 items-center gap-3 pr-6">
              @if (selectedCampaign(); as campaign) {
              <img
                [src]="campaign.campaignPhoto ? imageService.getImageSource(campaign.campaignPhoto, 'gallery') : 'https://ionicframework.com/docs/img/demos/avatar.svg'"
                alt=""
                class="size-5 shrink-0 rounded-full bg-gray-300 outline -outline-offset-1 outline-white/10 dark:bg-gray-700" />
              <span class="block truncate">{{ campaign.campaignName }}</span>
              } @else {
              <span
                class="flex size-5 shrink-0 items-center justify-center rounded-full outline -outline-offset-1 outline-white/10">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                  <path
                    d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2" />
                </svg>
              </span>
              <span class="block truncate">All Campaigns</span>
              }
            </span>
            <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
              class="col-start-1 row-start-1 size-4 self-center justify-self-end text-gray-400">
              <path
                d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                clip-rule="evenodd" fill-rule="evenodd" />
            </svg>
          </button>
          <el-options anchor="bottom start" popover class="dropdown-select-primary-menu scrollbar-transparent">
            <el-option value="" (click)="clearCampaign()"
              class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
              <div class="flex items-center">
                <span class="flex size-5 shrink-0 items-center justify-center rounded-full">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                    <path
                      d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2" />
                  </svg>
                </span>
                <span class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">All
                  Campaigns</span>
              </div>
            </el-option>
            @for (campaign of campaignList; track campaign.id) {
            <el-option [value]="campaign.id" (click)="chooseCampaign(campaign)"
              class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
              <div class="flex items-center">
                <img class="size-5 shrink-0 rounded-full" alt=""
                  [src]="campaign.campaignPhoto ? imageService.getImageSource(campaign.campaignPhoto, 'gallery') : 'https://ionicframework.com/docs/img/demos/avatar.svg'" />
                <span class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">{{
                  campaign.campaignName }}</span>
              </div>
            </el-option>
            }
          </el-options>
        </el-select>
        @if (selectedCampaign()) {
        <button type="button" class="btn-fab-primary shrink-0" aria-label="Edit campaign" (click)="editCampaign()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
            <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path
              d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
          </svg>
        </button>
        }
      </div>
      }

      <el-select class="block w-48 shrink-0" name="type">
        <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
          <span class="col-start-1 row-start-1 flex min-w-0 items-center gap-3 pr-6">
            <span
              class="flex size-5 shrink-0 items-center justify-center rounded-full outline -outline-offset-1 outline-white/10">
              @switch (query().types.length === 1 ? query().types[0] : 'all') {
              @case ('ugc') {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" class="size-5" aria-hidden="true">
                <path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z" />
                <path d="m6.2 5.3 3.1 3.9" />
                <path d="m12.4 3.4 3.1 4" />
                <path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
              </svg>
              }
              @case ('screening') {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" class="size-5" aria-hidden="true">
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.3-4.3" />
                <path d="M11 8v6" />
                <path d="M8 11h6" />
              </svg>
              }
              @case ('monitoring') {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" class="size-5" aria-hidden="true">
                <path d="M19.07 4.93A10 10 0 0 0 6.99 3.34" />
                <path d="M4 6h.01" />
                <path d="M2.29 9.62A10 10 0 1 0 21.31 8.35" />
                <path d="M16.24 7.76A6 6 0 1 0 8.23 16.67" />
                <path d="M12 18h.01" />
                <path d="M17.99 11.66A6 6 0 0 1 15.77 16.67" />
                <circle cx="12" cy="12" r="2" />
                <path d="m13.41 10.59 5.66-5.66" />
              </svg>
              }
              @default {
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                <path
                  d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" />
                <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" />
                <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" />
              </svg>
              }
              }
            </span>
            <span class="block truncate">{{ typeFilterLabel() }}</span>
          </span>
          <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
            class="col-start-1 row-start-1 size-4 self-center justify-self-end text-gray-400">
            <path
              d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
              clip-rule="evenodd" fill-rule="evenodd" />
          </svg>
        </button>
        <el-options anchor="bottom start" popover class="dropdown-select-primary-menu scrollbar-transparent">
          <el-option value="" (click)="clearGroup('types')"
            class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
            <div class="flex items-center">
              <span class="flex size-5 shrink-0 items-center justify-center rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                  <path
                    d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" />
                  <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" />
                  <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" />
                </svg>
              </span>
              <span class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">All types</span>
            </div>
            @if (query().types.length === 0) {
            <span class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent" aria-hidden="true">
              <svg viewBox="0 0 20 20" fill="currentColor" class="size-5">
                <path
                  d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </span>
            }
          </el-option>
          @for (facet of typeFacets(); track facet.id) {
          <el-option [value]="facet.id" [attr.aria-selected]="typeOn(facet.id)" (click)="toggleType(facet.id)"
            class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
            <span class="flex w-full items-center gap-3 pr-4">
              <span class="flex size-5 shrink-0 items-center justify-center rounded-full">
                @switch (facet.id) {
                @case ('ugc') {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" class="size-5" aria-hidden="true">
                  <path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z" />
                  <path d="m6.2 5.3 3.1 3.9" />
                  <path d="m12.4 3.4 3.1 4" />
                  <path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
                </svg>
                }
                @case ('screening') {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" class="size-5" aria-hidden="true">
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.3-4.3" />
                  <path d="M11 8v6" />
                  <path d="M8 11h6" />
                </svg>
                }
                @default {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" class="size-5" aria-hidden="true">
                  <path d="M19.07 4.93A10 10 0 0 0 6.99 3.34" />
                  <path d="M4 6h.01" />
                  <path d="M2.29 9.62A10 10 0 1 0 21.31 8.35" />
                  <path d="M16.24 7.76A6 6 0 1 0 8.23 16.67" />
                  <path d="M12 18h.01" />
                  <path d="M17.99 11.66A6 6 0 0 1 15.77 16.67" />
                  <circle cx="12" cy="12" r="2" />
                  <path d="m13.41 10.59 5.66-5.66" />
                </svg>
                }
                }
              </span>
              <span class="block truncate font-normal group-aria-selected/option:font-semibold">{{ facet.name }}</span>
              <span class="ml-auto text-xs text-zinc-400">{{ facet.count }}</span>
            </span>
            @if (typeOn(facet.id)) {
            <span class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent" aria-hidden="true">
              <svg viewBox="0 0 20 20" fill="currentColor" class="size-5">
                <path
                  d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </span>
            }
          </el-option>
          }
        </el-options>
      </el-select>

      <el-select class="block w-48 shrink-0" name="product">
        <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
          <span class="col-start-1 row-start-1 flex min-w-0 items-center gap-3 pr-6">
            <span
              class="flex size-5 shrink-0 items-center justify-center rounded-full outline -outline-offset-1 outline-white/10">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                <path
                  d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                <path d="M12 22V12" />
                <path d="m3.3 7 8.7 5 8.7-5" />
                <path d="m7.5 4.27 9 5.15" />
              </svg>
            </span>
            <span class="block truncate">{{ productFilterLabel() }}</span>
          </span>
          <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
            class="col-start-1 row-start-1 size-4 self-center justify-self-end text-gray-400">
            <path
              d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
              clip-rule="evenodd" fill-rule="evenodd" />
          </svg>
        </button>
        <el-options anchor="bottom start" popover class="dropdown-select-primary-menu scrollbar-transparent">
          <el-option value="" (click)="clearGroup('products')"
            class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
            <div class="flex items-center">
              <span class="flex size-5 shrink-0 items-center justify-center rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                  <path
                    d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                  <path d="M12 22V12" />
                  <path d="m3.3 7 8.7 5 8.7-5" />
                  <path d="m7.5 4.27 9 5.15" />
                </svg>
              </span>
              <span class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">All products</span>
            </div>
            @if (query().products.length === 0) {
            <span class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent" aria-hidden="true">
              <svg viewBox="0 0 20 20" fill="currentColor" class="size-5">
                <path
                  d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </span>
            }
          </el-option>
          @for (facet of productFacets(); track facet.id) {
          <el-option [value]="facet.id" [attr.aria-selected]="query().products.includes(facet.id)"
            (click)="toggleProduct(facet.id)"
            class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
            <span class="flex w-full items-center gap-3 pr-4">
              <span class="flex size-5 shrink-0 items-center justify-center rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                  <path
                    d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                  <path d="M12 22V12" />
                  <path d="m3.3 7 8.7 5 8.7-5" />
                  <path d="m7.5 4.27 9 5.15" />
                </svg>
              </span>
              <span class="block truncate font-normal group-aria-selected/option:font-semibold">{{ facet.name }}</span>
              <span class="ml-auto text-xs text-zinc-400">{{ facet.count }}</span>
            </span>
            @if (query().products.includes(facet.id)) {
            <span class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent" aria-hidden="true">
              <svg viewBox="0 0 20 20" fill="currentColor" class="size-5">
                <path
                  d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </span>
            }
          </el-option>
          }
        </el-options>
      </el-select>

      <el-select class="block w-48 shrink-0" name="owner">
        <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
          <span class="col-start-1 row-start-1 flex min-w-0 items-center gap-3 pr-6">
            <span
              class="flex size-5 shrink-0 items-center justify-center rounded-full outline -outline-offset-1 outline-white/10">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </span>
            <span class="block truncate">{{ ownerFilterLabel() }}</span>
          </span>
          <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
            class="col-start-1 row-start-1 size-4 self-center justify-self-end text-gray-400">
            <path
              d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
              clip-rule="evenodd" fill-rule="evenodd" />
          </svg>
        </button>
        <el-options anchor="bottom start" popover class="dropdown-select-primary-menu scrollbar-transparent">
          <el-option value="" (click)="clearGroup('owners')"
            class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
            <div class="flex items-center">
              <span class="flex size-5 shrink-0 items-center justify-center rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </span>
              <span class="ml-3 block truncate font-normal group-aria-selected/option:font-semibold">All owners</span>
            </div>
            @if (query().owners.length === 0) {
            <span class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent" aria-hidden="true">
              <svg viewBox="0 0 20 20" fill="currentColor" class="size-5">
                <path
                  d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </span>
            }
          </el-option>
          @for (facet of ownerFacets(); track facet.id) {
          <el-option [value]="facet.id" [attr.aria-selected]="ownerSelected(facet.id)" (click)="toggleOwner(facet.id)"
            class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
            <span class="flex w-full items-center gap-3 pr-4">
              <span class="flex size-5 shrink-0 items-center justify-center rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </span>
              <span class="block truncate font-normal group-aria-selected/option:font-semibold">{{ facet.id === meId() ?
                'You' : facet.name }}</span>
              <span class="ml-auto text-xs text-zinc-400">{{ facet.count }}</span>
            </span>
            @if (ownerSelected(facet.id)) {
            <span class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent" aria-hidden="true">
              <svg viewBox="0 0 20 20" fill="currentColor" class="size-5">
                <path
                  d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </span>
            }
          </el-option>
          }
        </el-options>
      </el-select>

      <span class="hidden flex-1 lg:block"></span>

      <el-select class="block w-48 shrink-0" name="sort">
        <button type="button" class="grid w-full grid-cols-1 text-primary dropdown-select-primary-btn">
          <span class="col-start-1 row-start-1 flex min-w-0 items-center gap-3 pr-6">
            <span
              class="flex size-5 shrink-0 items-center justify-center rounded-full outline -outline-offset-1 outline-white/10">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                <path d="m3 16 4 4 4-4" />
                <path d="M7 20V4" />
                <path d="M11 4h10" />
                <path d="M11 8h7" />
                <path d="M11 12h4" />
              </svg>
            </span>
            <span class="block truncate">{{ sortLabel(query().sort) }}</span>
          </span>
          <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
            class="col-start-1 row-start-1 size-4 self-center justify-self-end text-gray-400">
            <path
              d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
              clip-rule="evenodd" fill-rule="evenodd" />
          </svg>
        </button>
        <el-options anchor="bottom end" popover class="dropdown-select-primary-menu scrollbar-transparent">
          @for (sort of sorts; track sort) {
          <el-option [value]="sort" [attr.aria-selected]="query().sort === sort" (click)="setSort(sort)"
            class="group/option relative block cursor-default py-2 pr-9 pl-3 text-primary select-none focus:bg-primary focus:text-primary-foreground focus:outline-hidden">
            <span class="block truncate font-normal group-aria-selected/option:font-semibold">{{ sortLabel(sort)
              }}</span>
            @if (query().sort === sort) {
            <span class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent" aria-hidden="true">
              <svg viewBox="0 0 20 20" fill="currentColor" class="size-5">
                <path
                  d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </span>
            }
          </el-option>
          }
        </el-options>
      </el-select>
    </div>
    <!-- Search & Filter Row - END -->

    <!-- Chips Row -->

    @if (chips().length) {
    <div class="flex flex-wrap items-center gap-1.5 w-full">
      @for (chip of chips(); track chip.group + chip.value) {
      <p
        class="m-0 inline-flex items-center gap-1 rounded-full border border-zinc-200 bg-white py-1 pl-3 pr-1 text-xs font-semibold text-zinc-800 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100">
        <span class="font-medium text-zinc-500">{{ chip.groupLabel }}:</span>
        {{ chip.valueLabel }}
        <button type="button"
          class="grid size-5 place-items-center rounded-full text-zinc-500 hover:bg-zinc-100 dark:hover:bg-zinc-800"
          [attr.aria-label]="'Remove ' + chip.groupLabel + ' filter'" (click)="removeChip(chip)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            class="size-3" aria-hidden="true">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </p>
      }
      <button type="button" class="btn-shout btn-shout-xs btn-shout-tertiary" (click)="clearFilters()">Clear
        all</button>
    </div>
    }
    <!-- Chips Row - END -->
  </div>
  <!-- header - END -->

  <!-- Main Content -->
  <div class="flex min-h-0 w-full flex-1 flex-col overflow-hidden">




    <div
      class="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-zinc-200 bg-white shadow-sm dark:border-zinc-800 dark:bg-zinc-900"
      [attr.aria-busy]="loading() === 'initial' || loading() === 'refresh'">
      @if (loading() === 'refresh') {
      <div class="h-0.5 shrink-0 overflow-hidden bg-primary/20" role="status" aria-label="Updating briefs">
        <div class="h-full w-1/3 animate-pulse bg-primary"></div>
      </div>
      }

      @if (loading() === 'error' && !response()) {
      <div class="flex flex-1 flex-col items-center justify-center gap-3 overflow-y-auto px-6 py-16 text-center">
        <h2 class="m-0 text-3xl font-bold use-grotesque">Could not load briefs</h2>
        <p class="m-0 max-w-md text-sm text-zinc-500">Something went wrong while loading this list.</p>
        <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary" (click)="retry()">Try again</button>
      </div>
      } @else if (empty(); as kind) {
      <div class="flex flex-1 flex-col items-center justify-center gap-3 overflow-y-auto px-6 py-16 text-center">
        @switch (kind) {
        @case ('first-run') {
        <h2 class="m-0 text-3xl font-bold use-grotesque">Create Your First Brief</h2>
        <p class="m-0 max-w-md text-sm text-zinc-500">Every brief you create lives here, with what needs your attention
          at the top.</p>
        <div class="mt-4 grid w-full max-w-3xl gap-3 text-left sm:grid-cols-3">
          <a routerLink="/create-brief-select-smart" [queryParams]="{ type: 'ugc' }"
            class="rounded-xl border border-zinc-200 p-4 hover:border-primary dark:border-zinc-700">
            <p class="m-0 font-bold">UGC Content</p>
            <p class="m-0 mt-1 text-sm text-zinc-500">Creators make original video content for your brand.</p>
          </a>
          <a routerLink="/create-brief-select-smart" [queryParams]="{ type: 'screening' }"
            class="rounded-xl border border-zinc-200 p-4 hover:border-primary dark:border-zinc-700">
            <p class="m-0 font-bold">Social Screening</p>
            <p class="m-0 mt-1 text-sm text-zinc-500">AI reviews creators’ past posts before you work with them.</p>
          </a>
          <a routerLink="/create-brief-select-smart" [queryParams]="{ type: 'monitoring' }"
            class="rounded-xl border border-zinc-200 p-4 hover:border-primary dark:border-zinc-700">
            <p class="m-0 font-bold">Social Monitoring</p>
            <p class="m-0 mt-1 text-sm text-zinc-500">AI watches creators’ posts over a live window.</p>
          </a>
        </div>
        }
        @case ('caught-up') {
        <h2 class="m-0 text-3xl font-bold use-grotesque text-emerald-800 dark:text-emerald-300">You’re All Caught Up
        </h2>
        <p class="m-0 max-w-md text-sm text-zinc-500">Nothing needs your attention right now. New flags, approvals and
          applicants will show up here.</p>
        <button type="button" class="btn-shout btn-shout-sm btn-shout-tertiary" (click)="setTab('live')">See live
          briefs</button>
        }
        @case ('no-match') {
        <h2 class="m-0 text-3xl font-bold use-grotesque">No Briefs Match</h2>
        <p class="m-0 max-w-md text-sm text-zinc-500">
          Nothing in {{ query().tab === 'all' ? 'your briefs' : tabLabel(query().tab) }} matches these filters.
          @if (query().tab !== 'all' && allCount() > 0) {
          There {{ response()!.tabCounts.all === 1 ? 'is 1 match' : 'are ' + response()!.tabCounts.all + ' matches' }}
          in All.
          }
        </p>
        <div class="flex flex-wrap justify-center gap-2">
          <button type="button" class="btn-shout btn-shout-sm btn-shout-tertiary" (click)="clearFilters()">Clear
            filters</button>
          @if (query().tab !== 'all' && allCount() > 0) {
          <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary" (click)="setTab('all')">Search all
            briefs</button>
          }
        </div>
        }
        @default {
        <h2 class="m-0 text-3xl font-bold use-grotesque">{{ emptyTitle() }}</h2>
        <p class="m-0 text-sm text-zinc-500">Nothing is in this tab right now.</p>
        }
        }
      </div>
      } @else {
      <div class="briefs-grid min-h-0 flex-1 overflow-y-auto">
      <div
        class="briefs-head sticky top-0 z-10 items-center gap-[14px] border-b border-zinc-100 bg-white px-[18px] py-2.5 text-xs font-bold uppercase tracking-wide text-zinc-500 dark:border-zinc-800 dark:bg-zinc-900">
        <button type="button" class="inline-flex items-center gap-1" (click)="setSort('name')">Brief @if (query().sort
          === 'name') { <span aria-hidden="true">↓</span> }</button>
        <p class="briefs-col-type m-0">Type</p>
        <p class="m-0">Status</p>
        <p class="m-0">Needs action</p>
        <button type="button" class="briefs-col-creators text-right" (click)="setSort('creators')">Creators @if
          (query().sort === 'creators') { <span aria-hidden="true">↓</span> }</button>
        <button type="button" class="text-left" (click)="setSort('end')">Ends @if (query().sort === 'end') { <span
            aria-hidden="true">↓</span> }</button>
        <span></span>
      </div>
        @if (loading() === 'initial') {
        @for (row of skeletonRows; track row) {
        <div class="grid grid-cols-1 gap-2 border-t border-zinc-100 px-4 py-3.5 dark:border-zinc-800"
          aria-hidden="true">
          <div class="skel h-4 w-1/2"></div>
          <div class="skel h-2.5 w-1/3"></div>
        </div>
        }
        } @else {
        @for (brief of response()?.rows ?? []; track brief.id) {
        <app-brief-row [brief]="brief" [meId]="meId()" [menuOpen]="menu() === 'row:' + brief.id"
          (rowEvent)="onRow(brief, $event)" (settingsUpdated)="onSettingsUpdated(brief, $event)" />
        }
        }
      </div>
      @if (loading() !== 'initial' && loading() !== 'error' && hasRows()) {
      <div
        class="sticky bottom-0 z-10 flex shrink-0 items-center justify-between gap-3 border-t border-zinc-100 bg-white px-4 py-2.5 dark:border-zinc-800 dark:bg-zinc-900">
        <p class="m-0 text-xs text-zinc-500">Showing {{ window().from }}–{{ window().to }} of {{ response()?.total }} {{
          response()?.total === 1 ? 'brief' : 'briefs' }}</p>
        @if (window().pages > 1) {
        <div class="flex gap-1">
          <button type="button" class="btn-shout btn-shout-xs btn-shout-secondary" aria-label="Previous page"
            [disabled]="query().page <= 1" (click)="setPage(-1)">Previous</button>
          <button type="button" class="btn-shout btn-shout-xs btn-shout-secondary" aria-label="Next page"
            [disabled]="query().page >= window().pages" (click)="setPage(1)">Next</button>
        </div>
        }
      </div>
      }
      }
    </div>
  </div>





  <!-- Main Content - END -->


</div>

@if (editingCampaign()) {
<create-campaign class="h-full w-full" [existingCampaign]="selectedCampaign()"
  (campaignCreated)="onCampaignSaved($event)" (close)="closeCampaignEditor()"></create-campaign>
}

@if (toast(); as note) {
<div
  class="fixed bottom-6 left-1/2 z-50 flex -translate-x-1/2 items-center gap-4 rounded-full bg-violet-950 px-4 py-2 text-sm text-white shadow-lg"
  role="status">
  <p class="m-0">{{ note.message }}</p>
  @if (note.undo) {
  <button type="button" class="font-bold text-violet-200 underline" (click)="undoToast()">Undo</button>
  }
</div>
}